module.exports = __webpack_public_path__ + "static/media/tickicon.5100de52.svg";